import React from 'react';
import { Icon } from '@ohif/ui';

interface ScrollArrowProps {
    visible: boolean;
    onScroll: () => void;
    className?: string;
}

/**
 * Reusable scroll arrow component
 */
export const ScrollArrow: React.FC<ScrollArrowProps> = ({
    visible,
    onScroll,
    className = "absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce text-white bg-black p-2 rounded-full shadow-lg"
}) => {
    if (!visible) return null;

    return (
        <button onClick={onScroll} className={className}>
            <Icon name="simple-Arrow-down" className="h-6 w-6" />
        </button>
    );
};
